import styled from "styled-components";
import {ListTitleTextDefaultBox} from "./list-title-text.default.box";
import {JACKPOT_WIDGET, RED_TIGER_JACKPOT} from "../../constants";

export const ListTitleTextCisBox = styled(ListTitleTextDefaultBox)`
    font-family: ${props => props.theme.font.family.secondary};
    background: none;
    border-left: none;
    padding: 0 0;
    
    .${JACKPOT_WIDGET} & {
      color: ${props => props.theme.components.gamesListTitle.colors.text.regular};
      border-left: none
    }

    .${RED_TIGER_JACKPOT} & {
      color: ${props => props.theme.components.gamesListTitle.colors.text.regular};
      border-left: none
    }
`;